
import React, { StrictMode } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

//contexts
import { AuthenticationContextProvider } from "./services/authentication/authentication.context";
import { GlobalMedicContextProvider } from "./services/global-medic/gobal-medic.context";

import { NotesPage } from "./features/notes/lecture-notes";
import { LandingPage } from "./features/landing/landing-page";
import { NotFoundPage } from "./features/landing/not-found";
import { ProjectsPage } from "./features/projects/projects";
import { QuestionsPage } from "./features/questions/questions";
import { JobsPage } from "./features/jobs/jobs";
import { LoginForm } from "./features/authentication/login";
import { SignupForm } from "./features/authentication/registration";
import { SendRecoveryEmail } from "./features/authentication/recoverymail";
import { ResetPassword } from "./features/authentication/reset-password";
import { ViewDocument } from "./features/notes/view-notes";
import { TutorialsPage } from "./features/tutorials/tutorials";
import ProtectedRoute from "./components/auth/private-route";
import { Dashboard } from "./features/admin/admin";
import { AnswersPage } from "./features/questions/answers";
import { AddNotesPage } from "./features/notes/add-notes";
import { AddProjectPage } from "./features/projects/add-project";
import { AddQuestion } from "./features/questions/add-question";
import { AskNoteAi } from "./features/questions/askAI";
import { MyProfilePage } from "./features/admin/profile";
import { AuthRedirect } from "./features/authentication/auth-redir";
import { ViewProject } from "./features/projects/view-project";
import AdminRoute from "./components/auth/admin-route";
import { clientId } from "./services/configs/server";
import { UserUpdate } from "./features/admin/profile-update";
import { TutorialAddPage } from "./features/tutorials/add-tutorial";
import { AddQuestions } from "./features/tutorials/add-questions";
import { TutorialDetails } from "./features/tutorials/tutorial-page";
import { UpdateTutorial } from "./features/tutorials/update-tutorials";
import { UpdateParts } from "./features/tutorials/update-parts";
import { PaymentPagent } from "./features/payment/payment";
import { UpdatePublication } from "./features/notes/update-document";
import { ActivateUser } from "./features/tutorials/activate-user";
import { LessonsPage } from "./features/resources/lessons";
import { LessonDetails } from "./features/tutorials/lesson";
import { AddLesson } from "./features/tutorials/add-lesson";
import { TutorialUpdatePage } from "./features/resources/tutorial-update";
import { EmailVerification } from "./features/authentication/verify-email";
import { QuestionAddPage } from "./features/HND/create-question";
import { PastQuestionPage } from "./features/HND/past-questions";
import { PastQuestionDocument } from "./features/HND/question-page";
import { QuestionUpdatePage } from "./features/HND/update-question";
import ScrollToTopButton from "./components/utilities/scroll-to-top";
import { ActivateHNDUser } from "./features/HND/subscribe-user";
import GlobalMedic from "./features/global-medic/global-medic";
import PostForm from "./features/global-medic/post-form";
import { AppUpdateNotifier } from "./features/admin/app-update";
import UpdateForm from "./features/global-medic/edit-discussion";
import GlobalDiscussion from "./features/global-medic/discussions";
import { GlobalBloPost } from "./features/global-medic/blogs";
import { GlobalCommunity } from "./features/global-medic/communities";

/**styles */
import "./styles/bgs.css";
import "./styles/note-header.css";
import "./styles/home.css";
import "./styles/alert.css";
import "./styles/tutorials.css";
import "./styles/lessons.css";
import "./styles/field-button.css";
import "./styles/p-questions.css";
import "./styles/mcqs.css";
import "./styles/success.css";
import './styles/global-medic.css';
import "./styles/global-home.css";


function App() {
  return (
    <StrictMode>
    <BrowserRouter>
      <GoogleOAuthProvider clientId={clientId}>
        <AuthenticationContextProvider>
          <GlobalMedicContextProvider>
            <ScrollToTopButton />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/lecture_notes" element={<NotesPage />} />
              <Route path="/research" element={<ProjectsPage />} />
              <Route path="/jobs_carreers" element={<JobsPage />} />
              <Route path="/questions" element={<QuestionsPage />} />
              <Route path="/login" element={<LoginForm />} />
              <Route path="/register" element={<SignupForm />} />
              <Route path="/recoveryemail" element={<SendRecoveryEmail />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/viewnotes" element={<ViewDocument />} />
              <Route path="/viewproject" element={<ViewProject />} />
              <Route path="/answers" element={<AnswersPage />} />
              <Route path="/tutorials" element={<TutorialsPage />} />
              <Route path="/lessons" element={<LessonsPage />} />
              <Route path="/verify" element={<EmailVerification />} />
              <Route element={<ProtectedRoute />} >
                <Route path="/myprofile" element={<MyProfilePage />} />
                <Route path="/tutorialpage" element={<TutorialDetails />} />
                <Route path="/userupdate" element={<UserUpdate />} />
                <Route path="/payment" element={<PaymentPagent />} />
                <Route path="/lessonpage" element={<LessonDetails />} />
                <Route path="/pastquestions" element={<PastQuestionPage />} />
                <Route path="/questiondoc" element={<PastQuestionDocument />} />
                <Route path="/globalmedic">
                   <Route path="" element={<GlobalMedic />} />
                   <Route path="discussion" element={<GlobalDiscussion />} />
                   <Route path="creatediscussion" element={<PostForm />} />
                   <Route path="editdiscussion" element={<UpdateForm />} />
                   <Route path="blogposts" element={<GlobalBloPost />} />
                   <Route path="communities" element={<GlobalCommunity />} />
                </Route>
                <Route element={<AdminRoute />} >
                  <Route path="/admin" element={<Dashboard />} />
                  <Route path="/update_publication" element={<UpdatePublication />} />
                  <Route path="/addtutorial" element={<TutorialAddPage />} />
                  <Route path="/addquestions" element={<AddQuestions />} />
                  <Route path="/activate" element={<ActivateUser />} />
                  <Route path="/activatehnd" element={<ActivateHNDUser />} />
                  <Route path="/updatetutorial" element={<UpdateTutorial />} />
                  <Route path="/update" element={<UpdateParts />} />
                  <Route path="/addlesson" element={<AddLesson />} />
                  <Route path="/update/tutorial" element={<TutorialUpdatePage />} />
                  <Route path="/addhndquestion" element={<QuestionAddPage />} />
                  <Route path="/updatehndquestion" element={<QuestionUpdatePage />} />
                  <Route path="/updateannounce" element= {<AppUpdateNotifier />} />
                </Route>
                <Route path="/addnote" element={<AddNotesPage />} />
                <Route path="/addproject" element={<AddProjectPage />} />
                <Route path="/addquestion" element={<AddQuestion />} />
                <Route path="/asknoteai" element={<AskNoteAi />} />
                <Route path="/authredir" element={<AuthRedirect />} />
              </Route>
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            </GlobalMedicContextProvider>
        </AuthenticationContextProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
    </StrictMode>
  );
}


export default App;
